import { Environment } from './environment.model';

export const environment: Environment = {
  productionMode: true,
  googleTagManagerId: 'GTM-N2RNF95',
  prismicEndpoint: 'https://yallo-support.cdn.prismic.io/api/v2',
  brand: 'yallo',
  fallbackLang: 'de',
  newMicroServiceEndpoint: 'https://prod.ms.api.yallo.ch',
  checkoutUrl: 'https://checkout.yallo.ch',
  allowedMsEnvs: [],
  defaultUrlsEnvironment: '',
  featureFlagClientKey: 'sdk-1AyWzT53SObto3SV',
  websiteUrl: 'https://www.yallo.ch',
  selfcareUrl: 'https://my.yallo.ch',
  sprinklerAppId: '6690eb6f187c274712e20ee8_app_220',
};
